import React, {useEffect, useState} from "react";
import {ReactKeycloakProvider} from "@react-keycloak/web";
import fetchData from "./Keycloak";
import Keycloak from "keycloak-js";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Login from "./components/Login";
import ManualCopCheck from "./pages/ManualCopCheck";
import PrivateRoute from "./helpers/PrivateRoute";
import AuditQuery from "./pages/AuditQuery";
import RoleAccsess from "./helpers/RoleAccsess";
import RoleAccsessSidebar from "./helpers/RoleAccsessSidebar";
import Reports from "./pages/Reports";
import RoleAccsessReport from "./helpers/RoleAccsessReport";

function App() {

    const [keycloak, setKeycloak] = useState(null);

    let url = window.location.href
    let arr = url.split("/");
    //url= arr[0] + "//" + arr[2];
    url = arr[0] + "//" + arr[2] + "/auth";

    console.log(url);

    useEffect(() => {
        fetchData()
            .then((data) => {
                const keycloakInstance = new Keycloak({
                    url: url, //TODO: change url!!!
                    realm: data.realm,
                    clientId: data.resource
                });
                setKeycloak(keycloakInstance);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }, []);

    if (keycloak === null) {
        return <div>Loading...</div>; // Return nothing until data is resolved
    }

    return (
        <ReactKeycloakProvider authClient={keycloak}>
            <BrowserRouter>
                <Routes>
                    <Route exact path="/login" element={
                        <Login />
                    } />
                    <Route exact path="/" element={
                        <PrivateRoute>
                            <RoleAccsess>
                                <ManualCopCheck />
                            </RoleAccsess>
                        </PrivateRoute>
                    } />
                    {/*<Route exact*/}
                    {/*    path="/ManualCopCheck"*/}
                    {/*    element={*/}
                    {/*        <PrivateRoute>*/}
                    {/*            <RoleAccsess>*/}
                    {/*                <ManualCopCheck />*/}
                    {/*            </RoleAccsess>*/}
                    {/*        </PrivateRoute>*/}
                    {/*    }*/}
                    {/*/>*/}
                    <Route exact
                           path="/AuditQuery"
                           element={
                               <PrivateRoute>
                                   <RoleAccsessSidebar>
                                       <AuditQuery />
                                   </RoleAccsessSidebar>
                               </PrivateRoute>
                           }
                    />
                    {/*<Route*/}
                    {/*    path="/AuditQueryTable"*/}
                    {/*    element={*/}
                    {/*        <PrivateRoute>*/}
                    {/*            <AuditQueryTable />*/}
                    {/*        </PrivateRoute>*/}
                    {/*    }*/}
                    {/*/>*/}
                    <Route
                        path="/Reports"
                        element={
                            <PrivateRoute>
                                <RoleAccsessReport>
                                    <Reports />
                                </RoleAccsessReport>
                            </PrivateRoute>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </ReactKeycloakProvider>
    );
}

export default App;